module.exports = __webpack_public_path__ + "static/img/roadFreight.4267b47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/roadFreight.png
// module id = DsYU
// module chunks = 44